export const isApple = (): boolean => {
  return /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform)
}

export const isIPhone = (): boolean => {
  return /(iPhone)/i.test(navigator.platform)
}

export const isAndroid = (): boolean => {
  return /(Android|Linux)/i.test(navigator.platform)
}

const ANDROID_APP_URL =
  'https://play.google.com/store/apps/details?id=com.beluga.moby'

const IOS_APP_URL = 'https://apps.apple.com/us/app/beluga-eats/id1557325188'

export const appDownloadUrl = (): string => {
  if (typeof window === 'undefined' || isApple()) {
    return IOS_APP_URL
  }
  return ANDROID_APP_URL
}
